import React from 'react';

const KVKKPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Kişisel Verilerin Korunması Kanunu (KVKK)</h1>
          <p className="text-xl text-teal-50">6698 Sayılı Kanun Kapsamında Aydınlatma Metni</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Veri Sorumlusu</h2>
                <p className="text-gray-600 leading-relaxed">
                  6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; 
                  veri sorumlusu olarak CLND Menkul Değerler A.Ş. tarafından aşağıda açıklanan kapsamda 
                  işlenebilecektir.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Kişisel Verilerin İşlenme Amacı</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>Sermaye piyasası faaliyetlerinin yürütülmesi</li>
                  <li>Müşteri ilişkilerinin yönetimi ve hizmet sunumu</li>
                  <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                  <li>SPK, BDDK ve diğer düzenleyici kuruluşların düzenlemelerine uyum</li>
                  <li>Risk yönetimi ve finansal raporlama</li>
                  <li>Müşteri memnuniyeti ve hizmet kalitesinin artırılması</li>
                  <li>İletişim faaliyetlerinin yürütülmesi</li>
                  <li>Pazarlama ve tanıtım faaliyetleri (açık rıza ile)</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. İşlenen Kişisel Veriler</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  Aşağıdaki kategorilerdeki kişisel verileriniz işlenebilmektedir:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li><strong>Kimlik Bilgileri:</strong> Ad, soyad, TC kimlik numarası, doğum tarihi ve yeri</li>
                  <li><strong>İletişim Bilgileri:</strong> Telefon numarası, e-posta adresi, adres</li>
                  <li><strong>Müşteri İşlem Bilgileri:</strong> Hesap numarası, portföy bilgileri, işlem geçmişi</li>
                  <li><strong>Finansal Bilgiler:</strong> Banka hesap bilgileri, gelir durumu, varlık bilgileri</li>
                  <li><strong>Görsel ve İşitsel Kayıtlar:</strong> Fotoğraf, video kayıtları, çağrı kayıtları</li>
                  <li><strong>Mesleki Deneyim:</strong> Eğitim durumu, meslek bilgisi, iş deneyimi</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebep</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  Kişisel verileriniz, elektronik veya fiziki ortamda, aşağıdaki hukuki sebeplerle toplanmaktadır:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>Açık rızanızın bulunması</li>
                  <li>Kanunlarda açıkça öngörülmesi</li>
                  <li>Sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması</li>
                  <li>Hukuki yükümlülüğümüzün yerine getirilmesi</li>
                  <li>Meşru menfaatlerimiz için veri işlemenin zorunlu olması</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Kişisel Verilerin Aktarılması</h2>
                <p className="text-gray-600 leading-relaxed">
                  Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda; 
                  SPK, BDDK, Merkezi Kayıt Kuruluşu, Takasbank gibi resmi kurumlara, bankalar, 
                  aracı kurumlar ve hukuki yükümlülüklerimiz gereği yetkili kamu kurum ve kuruluşlarına 
                  KVKK'da öngörülen güvenlik standartlarına uygun şekilde aktarılabilecektir.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Kişisel Veri Sahibinin Hakları</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  KVKK'nın 11. maddesi uyarınca, kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                  <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                  <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                  <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme</li>
                  <li>Kişisel verilerin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme</li>
                  <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerin silinmesini veya yok edilmesini isteme</li>
                  <li>Kişisel verilerin düzeltilmesi, silinmesi veya yok edilmesi halinde bu işlemlerin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</li>
                  <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
                  <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması halinde zararın giderilmesini talep etme</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Başvuru Yöntemi</h2>
                <p className="text-gray-600 leading-relaxed mb-3">
                  Yukarıda belirtilen haklarınızı kullanmak için başvurunuzu aşağıdaki yöntemlerle iletebilirsiniz:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>Yazılı olarak şirket adresimize</li>
                  <li>destek@clndonlinesube.com e-posta adresine</li>
                  <li>Kayıtlı elektronik posta (KEP) adresi üzerinden</li>
                  <li>Güvenli elektronik imza ile</li>
                </ul>
                <p className="text-gray-600 leading-relaxed mt-3">
                  Başvurularınız, talebin niteliğine göre en kısa sürede ve en geç 30 (otuz) gün içinde 
                  ücretsiz olarak sonuçlandırılacaktır. İşlemin ayrıca bir maliyeti gerektirmesi halinde, 
                  Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret alınacaktır.
                </p>
              </div>

              <div className="bg-teal-50 p-6 rounded-lg mt-8">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">İletişim</h3>
                <p className="text-gray-600">
                  <strong>E-posta:</strong> destek@clndonlinesube.com<br />
                  <strong>Şirket:</strong> CLND Menkul Değerler A.Ş.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default KVKKPage;
